import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box, Typography, Grid, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, CircularProgress, Alert
} from '@mui/material';
import { contactService } from '../../services/contactService';
import ContactDetail from './ContactDetail';

const ContactList = () => {
  const { project } = useParams();
  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        setLoading(true);
        const data = await contactService.getContacts(project);
        setContacts(data);
        if (data.length > 0) {
          setSelectedContact(data[0]); // Auto-select first contact
        }
      } catch (err) {
        console.error('Error fetching contacts:', err);
        setError('Failed to load contacts.');
      } finally {
        setLoading(false);
      }
    };

    if (project) {
      fetchContacts();
    }
  }, [project]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Contacts
      </Typography>

      {error && <Alert severity="error" sx={{ mb: 4 }}>{error}</Alert>}

      <Grid container spacing={3}>
        {/* Left Side: Contact List Table */}
        <Grid item xs={12} md={7}>
          <TableContainer component={Paper} sx={{ maxHeight: '70vh' }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell><strong>ID</strong></TableCell>
                  <TableCell><strong>Email</strong></TableCell>
                  <TableCell><strong>Name</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {contacts.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={3} align="center">No contacts found</TableCell>
                  </TableRow>
                ) : (
                  contacts.map((contact) => (
                    <TableRow
                      key={contact._id}
                      hover
                      onClick={() => setSelectedContact(contact)}
                      selected={selectedContact?._id === contact._id}
                      sx={{ cursor: 'pointer' }}
                    >
                      <TableCell>{contact.contactId}</TableCell>
                      <TableCell>{contact.email}</TableCell>
                      <TableCell>{`${contact.first_name || ''} ${contact.last_name || ''}`}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        {/* Right Side: Contact Details */}
        <Grid item xs={12} md={5}>
          <ContactDetail contact={selectedContact} projectId={project} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContactList;
